import { Box, ClickAwayListener, Popover } from "@mui/material";
import { CompanyFile, Dashboard } from "../../../../../types/files";
import DeckListContentCard from "../../../../molecules/home-companies/DeckListContentCard";

const DeckListModal: React.FC<{
    open: boolean,
    dashboard: Dashboard,
    files?: CompanyFile[],
    anchorElement?: HTMLElement|null,
    onSetDeck?: (file: CompanyFile) => Promise<any>,
    onClose: () => void,
 }> = ({ open, dashboard, files, anchorElement, onSetDeck, onClose }) => {
    return (<>
        <Popover open={open} anchorEl={anchorElement}>
            <ClickAwayListener onClickAway={onClose}>
                <Box width="fit-content" height="fit-content">
                    <DeckListContentCard
                        dashboard={dashboard}
                        files={files}
                        onSetDeck={onSetDeck} />
                </Box>
            </ClickAwayListener>
        </Popover>
    </>);
}

export default DeckListModal;